import { render, staticRenderFns } from "./tabZujianChild4.vue?vue&type=template&id=79de6574&"
import script from "./tabZujianChild4.vue?vue&type=script&lang=js&"
export * from "./tabZujianChild4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports